import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import React from "react";
import AuthLayout from "../layout/auth";
import PageTransition from "../components/ui-elements/pageTransition";
import Signup from "../pages/authentication/sign-up";
import Login from "../pages/authentication/login";
import OnboardingLayout from "../layout/onboarding";
import Onboarding from "../pages/onboarding";
import DashboardLayout from "../layout/dashboard";
import Dashboard from "../pages/dashboard";
import Newsfeed from "../pages/newsfeed";
import Messages from "../pages/messages";
import Report from "../pages/dashboard/report";
import Representative from "../pages/dashboard/representative";
import Account from "../pages/account";
import Otp from "../pages/authentication/otp";
import Edit from "../pages/account/edit";
import Representatative from "../pages/representative";
import AuthGuard from "../hooks/useAuthGuard";
import ProtectedRoute, { ProtectedRepresentativeRoute } from "../hooks/useVerify";
import OnboardingAccount from "../pages/onboarding/account";
import SearchPage from "../pages/search";
import UnAuthenticatedPosts from "../pages/posts";
import Terms from "../pages/account/terms";
import Privacy from "../pages/account/privacy";
import FAQ from "../pages/account/faq";
import ForgotPassword from "../pages/authentication/forgot-password";

export default function Router() {
  const routes = useRoutes([
    {
      path: "auth",
      element: <AuthLayout />,
      children: [
        {
          path: "sign-up",
          element: (
            <PageTransition>
              <Signup />
            </PageTransition>
          ),
        },
        {
          path: "sign-in",
          element: (
            <PageTransition>
              <Login />
            </PageTransition>
          ),
        },
        {
          path: "forgot-password",
          element: (
            <PageTransition>
              <ForgotPassword />
            </PageTransition>
          ),
        },
        {
          path: "otp-code",
          element: (
            <PageTransition>
              <Otp />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "posts",
      element: <OnboardingLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <UnAuthenticatedPosts />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "onboarding",
      element: <OnboardingLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <Onboarding />
            </PageTransition>
          ),
        },
        {
          path: "account",
          element: (
            <PageTransition>
              <OnboardingAccount />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "representative",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <Representatative />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "dashboard",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Dashboard />
              </PageTransition>
            </AuthGuard>
          ),
        },
        {
          path: "post",
          element: (
            <PageTransition>
              <Report />
            </PageTransition>
          ),
        },
        {
          path: "representative",
          element: (
            <ProtectedRepresentativeRoute>
            <PageTransition>
              <Representative />
            </PageTransition>
            </ProtectedRepresentativeRoute>
          ),
        },
      ],
    },
    {
      path: "newsfeed",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <PageTransition>
                <Newsfeed />
              </PageTransition>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "search",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <PageTransition>
              <SearchPage />
            </PageTransition>
          ),
        },
      ],
    },
    {
      path: "messages",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <ProtectedRepresentativeRoute>
                <PageTransition>
                  <Messages />
                </PageTransition>
              </ProtectedRepresentativeRoute>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "account",
      element: <DashboardLayout />,
      children: [
        {
          path: "",
          element: (
            <AuthGuard>
              <ProtectedRoute>
                <PageTransition>
                  <Account />
                </PageTransition>
              </ProtectedRoute>
            </AuthGuard>
          ),
        },
        {
          path: "edit",
          element: (
            <AuthGuard>
              <ProtectedRoute>
                <PageTransition>
                  <Edit />
                </PageTransition>
              </ProtectedRoute>
            </AuthGuard>
          ),
        },
        {
          path: "faq",
          element: (
            <AuthGuard>
              <ProtectedRoute>
                <PageTransition>
                  <FAQ />
                </PageTransition>
              </ProtectedRoute>
            </AuthGuard>
          ),
        },
        {
          path: "terms",
          element: (
            <AuthGuard>
              <ProtectedRoute>
                <PageTransition>
                  <Terms />
                </PageTransition>
              </ProtectedRoute>
            </AuthGuard>
          ),
        },
        {
          path: "privacy",
          element: (
            <AuthGuard>
              <ProtectedRoute>
                <PageTransition>
                  <Privacy />
                </PageTransition>
              </ProtectedRoute>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/auth/sign-in" />,
    },
  ]);
  const location = useLocation();
  return (
    <>
      {/* <AnimatePresence mode="wait" initial={false}> */}
      {routes && React.cloneElement(routes, { key: location.pathname })}
      {/* </AnimatePresence> */}
    </>
  );
}
